import React, {Component} from 'react'
import {
  Container, Segment, Table, Dimmer, Loader, Divider, Grid, Accordion, Icon, Form, Input
} from 'semantic-ui-react';
import _ from 'lodash';
import {Pagination} from "../utils/pagination";
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import history from "../../history";
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import {l, t} from "../../i18n";


function mapStateToProps(state) {
  return {
    getRequest: state.getRequest
  };
}

class ApiLogs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      options: [
        {text: t("filter.options.choose"), value: 'choose date type'},
        {text: t("filter.options.equal"), value: 'simple_date'},
        {text: t("filter.options.between"), value: 'is_between'},
        {text: t("filter.options.last"), value: 'last'},
        {text: t("filter.options.before"), value: 'before_date'},
        {text: t("filter.options.after"), value: 'after_date'},
      ],
      activeIndexDate: 0,
      activeIndexFilter: 0,
      activeIndexStatus: 0,
      data: [],
      meta: {
        count: '',
        current_page: '',
        per_page: '',
        last_page: '',
      },
      loading: true,
      page: 1,
      nextPage: '',
      prevPage: '',
      pages: [],
      status: '',
      showErrorMessage: false,
      search: '',
    }
  }

  componentDidMount() {
    this.props.actions.getRequest(this.state.page);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.getRequest !== this.props.getRequest) {
      let request = this.props.getRequest;
      if (request) {
        this.setState({
          loading: false,
          data: request.data,
          meta: request.meta
        })
      }
    }

    if (this.state.find) {
      this.find();
    }
  }

  getRequestDetails(code) {
    history.push(l + '/panel/logs/requests/' + code);
  }

  callPagination(options) {
    this.setState({
      current_page: options.pageNo,
      page: options.name,
      pages: options.pages,
      last_page: options.pagesCount,
      offset: options.offset,
      per_page: options.limit
    });
    let params = options.params;
    if (this.state.status)
      params.status = this.state.status;

    let query = this.state.queryData;
    let data = {
      page: options.pageNo,
      ...query,
    }

    let search = this.state.search;
    if (search) {
      data = {
        ...data,
        search
      }
    }

    this.props.actions.getRequest(data);
  }

  getApiRoute(headers) {
    let string = JSON.parse(headers);
    return string['x-api-route'];
  }

  changeDate = (e, date) => {
    if (null === date.value) {
      this.setState({date: null, find: true})
    } else {
      let datePicker = this.parseDate(date.value)
      this.setState({
        date: datePicker,
        find: true,
      });
    }
  };

  changeDateFrom = (e, date) => {
    if (null !== date.value) {
      let datePicker = this.parseDate(date.value)
      this.setState({
        dateFrom: datePicker,
        find: true
      });
    }
  }

  changeDateTo = (e, date) => {
    if (null !== date.value) {
      let datePicker = this.parseDate(date.value)
      this.setState({
        dateTo: datePicker,
        find: true
      });
    }
  }

  parseDate = (date) => date.getFullYear() + "-" + parseInt(date.getMonth() + 1) + "-" + date.getDate();
  handleChange = (e) => this.setState({dateType: e.target.value});
  handleInputStatus = (e) => {
    let value = e.target.value;
    if (value.length === 3) {
      this.setState({responseStatusCode: value, find: true, loading: false})
    } else if (value.length === 0) {
      this.setState({responseStatusCode: null, find: true})
    }
  }

  handleInputChange = (e, data) => this.setState({lastDate: data.value, find: true})

  find() {
    const {date, responseStatusCode, dateFrom, dateTo, dateType, lastDate, search} = this.state;
    let filter = {};

    if (responseStatusCode) filter.response_status = responseStatusCode;
    if (search && search.length > 2) filter.search = search;

    if (dateType === 'last' && lastDate) filter.in_the_last = lastDate;
    else if (dateType === 'before_date' && date) filter.before_date = date;
    else if (dateType === 'after_date' && date) filter.after_date = date;
    else if (dateType === 'simple_date' && date) filter.specific_date = date;
    else if (dateType === 'is_between' && dateFrom && dateTo) filter.between_date = [dateFrom, dateTo];

    let queryData = {filter: filter};
    this.props.actions.getRequest(queryData);
    this.setState({queryData, find: false})
  }

  handleClickData = (e, titleProps) => {
    const {index} = titleProps;
    const {activeIndexDate} = this.state;
    const newIndex = activeIndexDate === index ? -1 : index;
    this.setState({activeIndexDate: newIndex});
  }

  handleClickStatus = (e, titleProps) => {
    const {index} = titleProps;
    const {activeIndexStatus} = this.state;
    const newIndex = activeIndexStatus === index ? -1 : index;
    this.setState({activeIndexStatus: newIndex});
  }

  handleClickFilter = (e, titleProps) => {
    const {index} = titleProps;
    const {activeIndexFilter} = this.state;
    const newIndex = activeIndexFilter === index ? -1 : index;
    this.setState({
      activeIndexFilter: newIndex,
    });
  }

  handleSearchChange(event) {
    let search = event.target.value
    this.setState({search, find: true})
  }

  render() {
    const {activeIndexFilter, activeIndexDate, activeIndexStatus, dateType, options, data, meta} = this.state

    if (data && data.length === 1) {
      meta.current_page = 1;
      meta.last_page = 1;
      meta.per_page = 1
    }

    return (
      <Container>
        <Segment basic>
          <Dimmer inverted active={this.state.loading}>
            <Loader content={t("system.loading")}/>
          </Dimmer>
          <Divider horizontal className='list-title'>{t("apiLogs.apiRequestsLogs")}</Divider>
          <Grid stackable>
            <Grid.Row columns={2} className="filterBar">
              <Grid.Column floated='left' width={5}>
                <Form>
                  <Form.Group widths='equal'>
                    <Form.Field>
                      <Input
                        iconPosition={"left"}
                        icon={"search"}
                        size={"small"}
                        name='searchLogs'
                        placeholder={t("apiLogs.searchByRequestParams")}
                        value={this.state.search}
                        onChange={this.handleSearchChange.bind(this)}
                      />
                    </Form.Field>
                  </Form.Group>
                </Form>
              </Grid.Column>
              <Grid.Column floated='right' width={5} style={{zIndex: 10}}>
                <Accordion styled style={{zIndex: 10}}>
                  <Accordion.Title
                    content={t("apiLogs.filterRequests")}
                    active={activeIndexFilter === 1}
                    index={1}
                    onClick={this.handleClickFilter}
                    id="filter-list-header"
                    icon={"filter"}
                  />
                  <Accordion.Content active={activeIndexFilter === 1}>
                    <Accordion.Title
                      active={activeIndexDate === 1}
                      onClick={this.handleClickData}
                      index={1}
                      content="Date"
                      className="filter-list-title"
                    />
                    <Accordion.Content active={activeIndexDate === 1} content={
                      <Grid>
                        <Grid.Row>
                          <Grid.Column>
                            <div>
                              <Form>
                                <Form.Group widths='equal'>
                                  <Form.Field control='select' style={{padding: "5px"}} onChange={this.handleChange}>
                                    {options.map(option => (
                                      <option key={option.value} value={option.value}>{option.text}</option>
                                    ))}
                                  </Form.Field>
                                </Form.Group>
                              </Form>
                            </div>
                          </Grid.Column>
                        </Grid.Row>
                        {dateType === 'last' &&
                        <Grid>
                          <Grid.Row>
                            <Grid.Column>
                              <Input
                                size={"mini"}
                                icon='search'
                                placeholder='Days'
                                onChange={this.handleInputChange}
                                type="number"
                                min="1"
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>}
                        {(dateType === 'simple_date' || dateType === 'before_date' || dateType === 'after_date') &&
                        <Grid>
                          <Grid.Row>
                            <Grid.Column>
                              <SemanticDatepicker
                                locale="en-US"
                                onChange={this.changeDate}
                                datePickerOnly={true}
                                size={"mini"}
                                keepOpenOnSelect={true}
                                pointing={"right"}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>}
                        {dateType === 'is_between' &&
                        <Grid>
                          <div>From</div>
                          <Grid.Row>
                            <Grid.Column>
                              <SemanticDatepicker
                                locale="en-US"
                                onChange={this.changeDateFrom}
                                datePickerOnly={true}
                                size={"mini"}
                                keepOpenOnSelect={true}
                                pointing={"right"}
                              />
                            </Grid.Column>
                          </Grid.Row>
                          <div>To</div>
                          <Grid.Row>
                            <Grid.Column>
                              <SemanticDatepicker
                                locale="en-US"
                                onChange={this.changeDateTo}
                                datePickerOnly={true}
                                size={"mini"}
                                keepOpenOnSelect={true}
                                pointing={"right"}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>}
                      </Grid>
                    }/>

                    <Accordion.Title
                      active={activeIndexStatus === 1}
                      onClick={this.handleClickStatus}
                      index={1}
                      content="Status"
                      className="filter-list-title"
                    />
                    <Accordion.Content
                      active={activeIndexStatus === 1}
                      content={
                        <div>
                          <Grid>
                            <Grid.Row>
                              <Grid.Column>
                                <Input
                                  icon='search'
                                  size={"mini"}
                                  placeholder='Status code'
                                  onChange={this.handleInputStatus}
                                  type="number"
                                  min="2"
                                />
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </div>
                      }
                    />
                  </Accordion.Content>
                </Accordion>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <Table compact selectable={data.length > 0} stackable id="table">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign={"center"}>{t("apiLogs.responseStatus")}</Table.HeaderCell>
                <Table.HeaderCell textAlign={"center"}>{t("apiLogs.description")}</Table.HeaderCell>
                <Table.HeaderCell textAlign={"center"}>{t("apiLogs.created")}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            {data.length > 0 && <Table.Body>
              {_.map(data, ({code, createdAt, responseStatus, headers, url}) => (
                <Table.Row
                  key={code}
                  onClick={this.getRequestDetails.bind(this, code)}>
                  <Table.Cell textAlign={"center"}>{responseStatus}</Table.Cell>
                  <Table.Cell textAlign={"center"}>{this.getApiRoute(headers) ?? url}</Table.Cell>
                  <Table.Cell textAlign={"center"}>{createdAt}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>}

            {data.length === 0 && <Table.Body>
              <Table.Row textAlign="center">
                <Table.Cell colSpan={"4"}>
                  <Icon name={'search'}/>{t("apiLogs.noResultFound")}
                </Table.Cell>
              </Table.Row>
            </Table.Body>}
            <Table.Footer>
              <Pagination columnNumber={5} showFunction={this.callPagination.bind(this)}
                          pageNo={meta.current_page} pages={this.state.pages}
                          pagesCount={meta.last_page} limit={meta.per_page}/>
            </Table.Footer>
          </Table>
        </Segment>
      </Container>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {actions: bindActionCreators(actions, dispatch)};
}

export default connect(mapStateToProps, mapDispatchToProps)(ApiLogs)
